module.exports = __webpack_public_path__ + "static/media/ChickenSans-Regular.7f3a74e9.woff";